import { ProductCreateDto } from '@@types/api.types';
import {
  LONG_DESCRIPTION_MAX_LENGTH,
  LONG_DESCRIPTION_VALIDATION_MESSAGES,
  NAME_MAX_LENGTH,
  NAME_MIN_LENGTH,
  NAME_VALIDATION_MESSAGES,
} from '@azymmetric/shared/validation/validation.constants';
import { z } from 'zod';

export const productSchema = z.object({
  description: z
    .string()
    .max(LONG_DESCRIPTION_MAX_LENGTH, { message: LONG_DESCRIPTION_VALIDATION_MESSAGES.max })
    .optional(),
  name: z
    .string()
    .min(NAME_MIN_LENGTH, { message: NAME_VALIDATION_MESSAGES.min })
    .max(NAME_MAX_LENGTH, { message: NAME_VALIDATION_MESSAGES.max }),
  technologyIds: z.array(z.string().uuid()).optional(),
}) satisfies z.ZodType<ProductCreateDto>;

export const selectProductsSchema = z.object({
  selectedProductIds: z.array(z.string().uuid()),
});

export type ProductFormData = z.infer<typeof productSchema>;
export type SelectProductsFormData = z.infer<typeof selectProductsSchema>;
